import React, { useState, useEffect } from "react";
import { Button } from "react-bootstrap";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { useLocation, useParams, Link } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { toast } from "react-toastify";
import Modal from "react-bootstrap/Modal";
import ls from "local-storage";
import Moment from "react-moment";
import * as CONFIG from "./_config";
import Swal from "sweetalert2";
import "./css/cart.css";

import { Helmet } from "react-helmet";

const axios = require("axios");

function ___ProductListing(props) {
  const products = props ? props.products : null;
  if (!products) {
    return <Loading />;
  } else if (products.length === 0) {
    return <NoProducts />;
  }
  return <ProductList products={products} />;
}

function NoProducts() {
  return (
    <React.Fragment>
      <div className="content">
        <div className="overlay">
          <div className="overlay-content">
            <img
              style={{ maxWidth: "none" }}
              src="/assets/images/loading.gif"
              alt="Loading..."
            />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

function Loading() {
  return (
    <React.Fragment>
      <div className="content">
        <div className="overlay">
          <div className="overlay-content">
            <img
              style={{ maxWidth: "none" }}
              src="/assets/images/loading.gif"
              alt="Loading..."
            />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

function DepartmentsList(props) {
  const {
    department: [department, setDepartment],
  } = {
    department: useState(props.department),
    ...(props.state || {}),
  };

  const {
    store: [store, setStore],
  } = {
    store: useState(props.store),
    ...(props.state || {}),
  };

  // const [department, setDepartment] = useState(0);
  const [departmentList, setDepartmentList] = useState();
  const [storeName] = useState(ls.get("storeName"));
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const IsLoggedIn = true;
  let CurrentProductCategoryId = department;

  async function fetchDepartments() {
    var UserToken = ls.get(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`)
      ? ls.get(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`).UserToken
      : CONFIG.DATA.GUEST_TOKEN_USER;
    if (!UserToken) {
      setDepartmentList([]);
      return;
    }

    setIsLoading(true);
    const data = new FormData();
    data.append("method", "POST");
    const apiurl = `https://ra14ql4rs6.execute-api.us-east-1.amazonaws.com/prod/GetCategoriesForCoupons/${UserToken}`;

    var object = {};
    data.forEach((value, key) => (object[key] = value));
    var jsonData = JSON.stringify(object);

    axios
      .post(apiurl, jsonData, {
        headers: { domainname: CONFIG.DATA.RSA_SUBDOMAIN },
      })
      .then((res) => {})
      .catch(function (response) {
        console.log(response);
      });

    try {
      const response = await axios({
        method: "POST",
        url: apiurl,
        data: jsonData,
        headers: { domainname: CONFIG.DATA.RSA_SUBDOMAIN },
      });
      console.log(response.data);
      if (response.data.GetProductCategories) {
        let department_list = response.data.GetProductCategories;
        var user_dept = department_list.filter(
          (a) => a.ProductCategoryId >= 10000
        );
        user_dept.sort((a, b) => a.ProductCategoryId < b.ProductCategoryId);

        var generic_dept = department_list.filter(
          (a) => a.ProductCategoryId < 10000
        );
        generic_dept.sort((a, b) =>
          a.ProductCategoryName.localeCompare(b.ProductCategoryName)
        );
        var merged_list = [...user_dept, ...generic_dept];

        setDepartmentList(merged_list);
      } else {
        setDepartmentList([]);
      }
      //this.Coupanlist();
      setIsLoading(false);
    } catch (error) {
      setIsError(true);
    }
  }

  useEffect(() => {
    console.log("useEffect", store);
    if (store && store > 0) {
      fetchDepartments();
    }
  }, [store]); // Only re-run the effect if 'store' changes

  return (
    <React.Fragment>
      <div className="col-md-3 ">
        <div
          style={{
            border: "1px solid gray",
            padding: "4px",
            marginTop: "10px",
            textAlign: "left",
          }}
        >
          You are in <b style={{ color: "red" }}>{storeName}</b>{" "}
          <Link
            to="#"
            onClick={() => {
              setStore(0);
            }}
          >
            Click here to Change Store
          </Link>
        </div>
        <div style={{ marginTop: "20px", textAlign: "left" }}>
          <h3 style={{ marginBottom: "25px" }}>Departments</h3>
          <div className="department_list">
            <ul
              className="department_list"
              style={{ listStyle: "none", paddingLeft: "0px" }}
            >
              {isError && <div>Something went wrong ...</div>}
              {isLoading && <div>Loading ...</div>}
              {departmentList && (
                <React.Fragment>
                  <ul
                    className="departmentlist"
                    style={{ paddingBottom: "20px" }}
                  >
                    {departmentList.map((value, index) => {
                      if (IsLoggedIn || value.ProductCategoryId !== 10001) {
                        // && value.ProductCategoryId !== 10002)){
                        return (
                          <li key={index} className="all_department">
                            <Link
                              style={
                                CurrentProductCategoryId ===
                                value.ProductCategoryId
                                  ? {
                                      color: CONFIG.DATA.LOGO_COLOR,
                                      fontWeight: "bold",
                                    }
                                  : { color: "#6c6a6a" }
                              }
                              id="all_0"
                              className={`all_0 anchor coupens`}
                              to={
                                "/shop/" +
                                ls.get("store") +
                                "/" +
                                value.ProductCategoryId
                              }
                              onClick={(e) => {
                                props.singleproductdetails({});
                                ls.set("department", value.ProductCategoryId);
                                setDepartment(value.ProductCategoryId);
                              }}
                              data-id="0"
                            >
                              <span className="vc_tta-title-text">
                                {value.ProductCategoryName}
                              </span>
                              <span className="coupon_count">
                                {" "}
                                ({value.NoOfCoupons})
                              </span>
                            </Link>
                          </li>
                        );
                      }
                    })}
                  </ul>
                </React.Fragment>
              )}
            </ul>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

function ProductList(props) {
  const {
    department: [department, setDepartment],
  } = { store: useState(props.department), ...(props.state || {}) };

  // const [department, setDepartment] = useState(0);
  // const [product, setProduct] = useState(0);
  const [productList, setProductList] = useState(null);
  const [store, setStore] = useState(ls.get("store"));
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const IsLoggedIn = true;
  let ProductCategoryId = department;

  // let location = useLocation();
  // let { id } = useParams();
  // console.log(location, id);

  async function fetchProducts() {
    var UserToken = ls.get(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`)
      ? ls.get(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`).UserToken
      : CONFIG.DATA.GUEST_TOKEN_USER;
    setIsLoading(true);
    const data = new FormData();
    data.append("method", "POST");

    const apiurl = `https://ra14ql4rs6.execute-api.us-east-1.amazonaws.com/prod/GetDetailsForCoupons/${ProductCategoryId}/${UserToken}/0`;

    var object = {};
    data.forEach((value, key) => (object[key] = value));
    var jsonData = JSON.stringify(object);

    try {
      const response = await axios({
        method: "POST",
        url: apiurl,
        data: jsonData,
        headers: { domainname: CONFIG.DATA.RSA_SUBDOMAIN },
      });
      console.log(response.data);

      if (response.data.Specials) {
        if (ls.get("ProductNameformUrl")) {
          response.data.Specials.map((list) => {
            if (
              list.ProductName.replace(/\s/g, "-").replace(/\//g, "-") ==
              ls.get("ProductNameformUrl")
            ) {
              props.singleproductdetails(list);
              ls.remove("ProductNameformUrl");
            }
          });
        }
        setProductList(response.data.Specials);
      } else {
        setProductList([]);
      }
      setIsLoading(false);
    } catch (error) {
      setIsError(true);
    }
  }

  useEffect(() => {
    console.log("useEffect ProductList store", store);
    if (store && store > 0) {
      fetchProducts();
    }
  }, [department]); // Only re-run the effect if 'store' changes

  if (!productList) {
    return <Loading />;
  } else if (productList.length === 0) {
    return <NoProducts />;
  } else {
    return (
      productList &&
      productList.map((product, index) => {
        return (
          <SingleProduct
            key={index}
            index={index}
            product={product}
            mycart={props.mycart}
            singleproductdetails={props.singleproductdetails}
          />
        );
      })
    );
  }
}

function SingleProduct(props) {
  const [showQuickView, setShowQuickView] = useState(false);
  const [currentProduct, setCurrentProduct] = useState(null);
  const singleproductdetails = props.singleproductdetails;

  var product = props.product;
  var index = props.index;

  var productInCart = product.IsInCart;
  var productDetails = product.Details;
  var productNewsCategoeyId = product.NewsCategoryId;
  var productTitle = product.Title;
  if (productNewsCategoeyId === 4) {
    productTitle = product.ProductName;
  }

  var productTitleShow = productTitle;
  if (productTitle != null && productTitle.length > 35) {
    productTitleShow = productTitle.substring(0, 35) + "...";
  }

  const AddtoCart = (e, product) => {
    props.mycart(product);
  };

  const url = window.location.href;

  // var page = (index+1);

  var cartTitle = CONFIG.DATA.ADD_TO_CART_TEXT;
  if (productInCart === true) {
    cartTitle = CONFIG.DATA.REMOVE_FROM_CART_TEXT;
  }

  return (
    <div className="col-md-3">
      <div
        className="coupons item-col  col-full-hd product type-product status-publish has-post-thumbnail product_cat-dress product_cat-drink product_cat-fashion first instock sale shipping-taxable purchasable product-type-simple"
        style={{ minWidth: "221px" }}
      >
        <div className="product-wrapper" title={productTitleShow}>
          <div className="gridview">
            <div className="list-col4  ">
              <div
                id={`add_to_cart_shape_${index}`}
                className="add_to_cart_shape coupons"
                style={{ display: productInCart ? "block" : "none" }}
              >
                <img
                  alt="Already in Cart"
                  loading="lazy"
                  src="/assets/images/shape_1.png"
                />
              </div>
              <div className="product-image">
                <Link
                  to="#"
                  className="woocommerce-LoopProduct-link woocommerce-loop-product__link"
                  onClick={(e) => {
                    setCurrentProduct(product);
                    setShowQuickView(true);
                  }}
                >
                  <div className="product-image-div">
                    <img
                      loading="lazy"
                      width="300"
                      height="300"
                      src={product.ImagePath}
                      className="primary_image"
                      alt="Coupon"
                      title={productTitleShow}
                      style={{ height: "100%", objectFit: "contain" }}
                    />
                  </div>
                </Link>
              </div>
              <div className="quickviewbtn" style={{ zIndex: "99" }}>
                <Link
                  to="#"
                  onClick={(e) => {
                    setCurrentProduct(product);
                    setShowQuickView(true);
                  }}
                  className="quickview1"
                  href="#"
                  title={productTitleShow}
                >
                  Quick View
                </Link>
                <Link
                  className="quickview1 mt-1"
                  to={
                    "/shop/" +
                    ls.get("store") +
                    "/" +
                    ls.get("department") +
                    "/" +
                    product.ProductName.replace(/\s/g, "-").replace(/\//g, "-")
                  }
                  onClick={() => {
                    singleproductdetails(product);
                  }}
                  title={productTitleShow}
                >
                  Detail View
                </Link>
              </div>
            </div>
            <div className="list-col8 ">
              {/*<h2 className="product-name"><a href="#">SAVE {product.PLUCode}</a></h2>*/}
              <h4 className="product-name">
                <Link to="#">{productTitleShow}</Link>
              </h4>
              <div className="ratings"></div>
              <ul className="actions">
                <li className="add-to-cart">
                  <button
                    onClick={(e) => {
                      AddtoCart(e, props.product);
                    }}
                    rel="nofollow"
                    id={`add_to_cart_${index}`}
                    className="quickview btn btn-theme add_to_cart"
                  >
                    <span
                      id={`span_add_to_cart_${index}`}
                      data-action={productInCart ? "remove" : "add"}
                      className="title-cart"
                    >
                      {cartTitle}
                    </span>
                  </button>
                </li>
              </ul>
            </div>
          </div>
          <div className="clearfix"></div>
          {showQuickView ? (
            <Modal
              show={showQuickView}
              size="lg"
              dialogClassName="modal-60w"
              centered
              onHide={() => {
                setShowQuickView(false);
                setCurrentProduct(null);
              }}
            >
              <Modal.Header closeButton>
                <Modal.Title>{currentProduct.ProductName}</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="row">
                  <div className=" col-md-3">
                    <img
                      alt={currentProduct.ProductName}
                      loading="lazy"
                      src={currentProduct.ImagePath}
                      title={currentProduct.ProductName}
                    />
                  </div>
                  <div className="col-md-9">
                    <h6
                      className="offer-expires"
                      style={{ color: "red", fontStyle: "italic" }}
                    >
                      Offer Expires on{" "}
                      <Moment unix format={"MM/DD/YYYY"}>
                        {currentProduct.ExpiresOn
                          ? currentProduct.ExpiresOn.replace("/", "")
                              .replace("/", "")
                              .replace("Date(", "")
                              .replace(")", "")
                              .replace("000+0000", "")
                              .replace(" ", "")
                          : ""}
                      </Moment>
                    </h6>

                    <button
                      onClick={(e) => {
                        AddtoCart(e, props.product);
                      }}
                      rel="nofollow"
                      id={`add_to_cart_${index}`}
                      className="quickview btn btn-theme btn-outline basic-button add_to_cart"
                    >
                      <span
                        id={`span_add_to_cart_${index}`}
                        data-action={currentProduct.IsInCart ? "remove" : "add"}
                        className="title-cart"
                      >
                        {currentProduct.IsInCart
                          ? CONFIG.DATA.REMOVE_FROM_CART_TEXT
                          : CONFIG.DATA.ADD_TO_CART_TEXT}
                      </span>
                    </button>
                    <hr />
                    <p style={{ color: "#000000" }}>{currentProduct.Details}</p>
                  </div>
                </div>
              </Modal.Body>
            </Modal>
          ) : (
            ""
          )}
        </div>
      </div>
    </div>
  );
}

function DepartmentsAndProduct(props) {
  const {
    store: [store, setStore],
  } = { store: useState(props.store), ...(props.state || {}) };

  const details = props.details;

  const [department, setDepartment] = useState(ls.get("department"));

  useEffect(() => {
    console.log("details120000=>", Object.entries(details).length);
  }, [details]);

  return (
    <React.Fragment>
      {
        <DepartmentsList
          state={{
            department: [department, setDepartment],
            store: [store, setStore],
          }}
          singleproductdetails={props.singleproductdetails}
        />
      }
      <div className="col-md-9">
        {<Storetiming />}
        {/*{<Cart />}*/}
        <div className="shop-products grid-view mt-5">
          {
            <>
              <div
                className={
                  Object.entries(details).length == 0 ? "row" : "d-none"
                }
              >
                <ProductList
                  key={store}
                  state={{ department: [department, setDepartment] }}
                  singleproductdetails={props.singleproductdetails}
                  mycart={props.mycart}
                />
              </div>
              <div
                className={
                  Object.entries(details).length != 0
                    ? "col-md-12 mb-4 mt-4 "
                    : "d-none"
                }
              >
                <div className="">
                  {Object.entries(details).length != 0 ? (
                    <div className="single-item ">
                      <div className="left-set">
                        <img src={details.ImagePath} alt="image" />
                      </div>
                      <div className="right-set">
                        <div className="name">
                          <Link
                            to={
                              "/shop/" +
                              ls.get("store") +
                              "/" +
                              ls.get("department")
                            }
                            value
                            type="button"
                            onClick={() => {
                              props.singleproductdetails({});
                            }}
                            className="btn btn-light btn-circle btn-xl back "
                          >
                            <i className="fa fa-reply fa-1x"></i>
                          </Link>
                        </div>
                        <div className="name">{details.ProductName}</div>
                        <div className="subname">{details.Title}</div>
                        <div className="price">${details.Amount}</div>
                        <div className="subname text-danger">
                          <b>ExpiresOn</b>:{" "}
                          <Moment unix format={"MM/DD/YYYY"}>
                            {details.ExpiresOn
                              ? details.ExpiresOn.replace("/Date(", "").replace(
                                  "000+0000)/",
                                  ""
                                )
                              : ""}
                          </Moment>
                        </div>
                        <div className="description">
                          <p>{details.Details}</p>
                        </div>
                        <div className="row">
                          <div className="col-12 mb-3">
                            <label htmlFor="comment float-left">Note:</label>
                            <textarea
                              className="form-control border"
                              rows="2"
                              id="productnote"
                            ></textarea>
                          </div>
                          <div className="col-6">
                            <div className="item-yk-head-specification cart_Quantity">
                              <form className="form-inline">
                                <div className="form-group">
                                  <label htmlFor="sel1">
                                    Select Quantity :
                                  </label>
                                  <select
                                    className="custom-select"
                                    id="select_quantity"
                                    defaultValue="1"
                                  >
                                    <option defaultValue="1">1</option>
                                    <option defaultValue="2">2</option>
                                    <option defaultValue="3">3</option>
                                    <option defaultValue="4">4</option>
                                    <option defaultValue="5">5</option>
                                    <option defaultValue="6">6</option>
                                    <option defaultValue="7">7</option>
                                    <option defaultValue="8">8</option>
                                    <option defaultValue="9">9</option>
                                    <option defaultValue="10">10</option>
                                  </select>
                                </div>
                              </form>
                            </div>
                          </div>
                          <div className="col-6">
                            <button
                              className="quickview1"
                              onClick={() => {
                                var option =
                                  document.getElementById("select_quantity");
                                var quantity =
                                  option.options[option.selectedIndex].text;
                                var note =
                                  document.getElementById("productnote").value;
                                props.singleproductdetails({});
                                props.mycart({
                                  ...details,
                                  quantity: quantity,
                                  note: note,
                                });
                              }}
                            >
                              {CONFIG.DATA.ADD_TO_CART_TEXT}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </>
          }
        </div>
      </div>
    </React.Fragment>
  );
}

function StoreSelection(props) {
  // const [store, setStore] = useState(ls.get("store") || 0);
  const [storeList, setStoreList] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const {
    store: [store, setStore],
  } = {
    store: useState(0),
    ...(props.state || {}),
  };

  async function fetch() {
    //console.log(store);

    const data = new FormData();
    setIsLoading(true);
    data.append("method", "POST");

    let apiurl = "";

    var UserToken = ls.get(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`)
      ? ls.get(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`).UserToken
      : null;
    if (CONFIG.DATA.LOAD_STORE_FROM_DIFFERENT_URL) {
      apiurl = `https://ra14ql4rs6.execute-api.us-east-1.amazonaws.com/prod/GetclientStoresbyClientapp/${CONFIG.DATA.RSA_CLIENT_STORE_GROUP_ID}/''`;
    } else {
      // NOTE: API IS SAME FOR LOGIN OR NON-LOGIN USERS
      if (UserToken)
        apiurl = `https://ra14ql4rs6.execute-api.us-east-1.amazonaws.com/prod/GetClientStores/1`;
      else
        apiurl = `https://ra14ql4rs6.execute-api.us-east-1.amazonaws.com/prod/GetClientStores/1`;
    }

    var object = {};
    data.forEach((value, key) => (object[key] = value));
    var jsonData = JSON.stringify(object);

    try {
      const response = await axios({
        method: "POST",
        url: apiurl,
        data: jsonData,
        headers: { domainname: CONFIG.DATA.RSA_SUBDOMAIN },
      });
      //console.log(response.data);
      setStoreList(response.data.GetClientStores);
      setIsLoading(false);
    } catch (error) {
      setIsError(true);
    }
  }

  useEffect(() => {
    console.log("useEffect StoreSelection store", store);
    if (!store || store === 0) {
      fetch();
    }
  }, [store]); // Only re-run the effect if 'store' changes

  return (
    <React.Fragment>
      <div className="col-md-12">
        <div className="row">
          <div className="" style={{ paddingTop: "100px", minHeight: "500px" }}>
            {isError && <div>Something went wrong ...</div>}
            {isLoading && <div>Loading ...</div>}
            {storeList && (
              <React.Fragment>
                <h1>Please select store</h1>
                <ul className="storelist">
                  {storeList.map((value, index) => {
                    return (
                      <li key={index}>
                        <Link
                          to={"/shop/" + value.ClientStoreId}
                          onClick={() => {
                            ls.set("store", value.ClientStoreId);
                            ls.set("storeName", value.ClientStoreName);
                            setStore(value.ClientStoreId);
                            ls.remove("ordercart");
                            props.singleproductdetails({});
                            props.mycart([], true);
                          }}
                        >
                          {value.ClientStoreName}
                        </Link>
                      </li>
                    );
                  })}
                </ul>
              </React.Fragment>
            )}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

function Cart() {
  const [cartItems, setCartItems] = useState([]);

  return (
    <React.Fragment>
      <div
        style={{
          border: "1px solid gray",
          padding: "4px",
          marginTop: "10px",
          textAlign: "left",
          opacity: 0,
        }}
      >
        You have <b> {cartItems.length > 0 || "No"} items</b> in cart.
        {cartItems.length > 0 && <a href="/cashsaver/shop/cart">View Cart</a>}
        <ul>
          {cartItems.length > 0 &&
            cartItems.map((item) => <li>{item.Name}</li>)}
        </ul>
      </div>
    </React.Fragment>
  );
}

function Shop() {
  const checkurl = window.location.href.split("/").splice(5, 3);

  if (checkurl.length === 3) {
    ls.set("store", parseInt(checkurl[0]));
    ls.set("department", parseInt(checkurl[1]));
    ls.set("ProductNameformUrl", checkurl[2]);
  }

  const [departments, setDepartments] = useState();
  const [products, setProducts] = useState();
  const [store, setStore] = useState(ls.get("store"));
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [mycartlist, setmycartlist] = useState(false);
  const [details, setdetails] = useState({});

  function mycart(product, isremove = false) {
    setmycartlist([]);
    const oldorders = ls.get("ordercart");
    if (!oldorders) {
      if (isremove) {
        ls.set("ordercart", JSON.stringify([]));
        setmycartlist([]);
      } else {
        if (product.quantity >= 1) {
          ls.set("ordercart", JSON.stringify([{ ...product }]));
          setmycartlist([{ ...product }]);
        } else {
          ls.set("ordercart", JSON.stringify([{ ...product, quantity: 1 }]));
          setmycartlist([{ ...product, quantity: 1 }]);
        }
      }
    } else {
      let new_order = JSON.parse(oldorders);

      if (product.quantity >= 1) {
        new_order.push({ ...product });
      } else {
        new_order.push({ ...product, quantity: 1 });
      }

      ls.set("ordercart", JSON.stringify(new_order));

      setmycartlist([new_order]);
    }
    if (isremove === false)
      toast.info("Item added to cart.", {
        autoClose: 2000,
        position: "top-center",
      });
  }

  function singleproductdetails(product, is_goback = false) {
    setdetails({ ...product });
  }

  useEffect(() => {
    console.log("useEffect Shop store", store);
  }, [store, details]); // Only re-run the effect if 'store' changes

  return (
    <div>
      <OrderCart mycartlist={mycartlist} />
      <div className="main-container default-page pt-5 mt-5  "></div>
      <div>
        <div className="container">
          <div className="main-container default-page">
            <div className="row">
              {store === 0 ? (
                <StoreSelection
                  state={{ store: [store, setStore] }}
                  mycart={mycart}
                  singleproductdetails={singleproductdetails}
                />
              ) : (
                <DepartmentsAndProduct
                  state={{ store: [store, setStore] }}
                  singleproductdetails={singleproductdetails}
                  details={details}
                  mycart={mycart}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function OrderCart({ mycartlist }) {
  const [cartoverlay, setcartoverlay] = useState(false);
  const [cartlist, setcartlist] = useState([]);
  const [carttotal, setcarttotal] = useState({ sub_total: 0, tax: 0 });
  const [is_payments, setis_payments] = useState(false);

  const [iscoupan, setiscoupan] = useState(false);

  const handleClose = () => setiscoupan(false);
  const handleShow = () => setiscoupan(true);

  function managequantity(index, newvalue) {
    const newlist = cartlist.map((value, key) => {
      if (key === index) {
        const newquantity = value.quantity + newvalue;
        if (newquantity >= 1) {
          return { ...value, quantity: newquantity };
        } else {
          toast.warn("Quantity must be at list one", {
            autoClose: 2000,
            position: "top-center",
          });
        }
      }
      return { ...value };
    });
    setcartlist([...newlist]);
    settotal(newlist);
    ls.set("ordercart", JSON.stringify([...newlist]));
  }

  function fetchOrders() {
    const orders = ls.get("ordercart");
    setcartlist([]);
    if (typeof orders === "string") {
      const list = JSON.parse(orders);
      setcartlist(JSON.parse(orders));
      settotal(list);
    }
  }
  function settotal(list) {
    const totalamount = list.reduce((a, b) => {
      return a + (b["quantity"] * b["Amount"] || 0);
    }, 0);
    setcarttotal({
      ...carttotal,
      sub_total: totalamount,
      tax: (totalamount * 10) / 100,
    });
  }

  function removeFromCart(index) {
    let oldcart = [...cartlist];
    oldcart.splice(index, 1);
    setcartlist(oldcart);
    settotal(oldcart);
    ls.set("ordercart", JSON.stringify(oldcart));
    toast.warn("Item removed from cart.", {
      autoClose: 2000,
      position: "top-center",
    });
  }

  function dumypaymet(name) {
    let timerInterval;
    Swal.fire({
      title: "Pay using " + name,
      html: "Wait until transaction is processed",
      timer: 4000,
      timerProgressBar: true,
      showConfirmButton: false,
      onClose: () => {
        clearInterval(timerInterval);
        Swal.fire({
          title: "payment done successfully.",
          timer: 1000,
        }).then(() => {
          setcartoverlay(false);
          setis_payments(false);
          setcartlist([]);
          settotal([]);
          ls.remove("ordercart");
        });
      },
    });
  }

  useEffect(() => {
    fetchOrders();
    document.body.style.overflow = "hidden";

    {
      document.body.style.overflow = "scroll";
    }
  }, [cartoverlay, mycartlist]);

  return (
    <div>
      <div
        className="row  mt-5 float-right position-fixed"
        style={{ right: "-18px" }}
      >
        <div
          className="col-12 border py-2 px-1 opencartbuttion "
          onClick={() => setcartoverlay(!cartoverlay)}
        >
          <button className="btn btn-light">
            {" "}
            <i className="fa fa-shopping-cart fa-2x"></i>
          </button>
          <div className="row">
            <div className="col-12 float-right">
              <b>Qty:{carttotal.sub_total || 0}</b>
            </div>
            <div className="col-12 float-left ">
              <b>${(carttotal.sub_total + carttotal.tax).toFixed(2) || 0.0}</b>
            </div>
          </div>
        </div>

        <Modal
          show={iscoupan}
          onHide={handleClose}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>Apply Promo Coupons</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-12 d-flex justify-content-center align-items-center flex-column ">
                <div className="d-flex w-50 my-3">
                  <input
                    type="email"
                    className="form-control border"
                    placeholder="Enter your Coupons"
                  />
                  <button className="btn btn-theme d-inline" type="submit">
                    Apply
                  </button>
                </div>
              </div>
              <div className="col-12 d-flex justify-content-around">
                <h3>Available Coupons</h3>
              </div>
              <div className="col-12 bg-secondary" style={{ minHeight: 20 }}>
                <div className="my-3">
                  <button className="btn btn-light mx-2 my-1">Growcer20</button>
                  <button className="btn btn-light mx-2 my-1">Growcer20</button>
                  <button className="btn btn-light mx-2 my-1">Growcer20</button>
                  <button className="btn btn-light mx-2 my-1">Growcer20</button>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </div>
      <div className={cartoverlay ? "cartoverlay" : "d-none"}>
        <div className="overlay transform">
          <div className="overlay__inner">
            <div className="overlay_cart">
              <div
                className="overlay_cart1"
                onClick={() => {
                  setcartoverlay(false);
                  setis_payments(false);
                }}
              ></div>
              <div
                className={
                  cartoverlay ? " overlay_cart2 " : "overlay_cart d-none"
                }
              >
                <div className="row mt-3 bg-light m-0">
                  <div className="col-6">
                    <h3 className="float-left ml-2 mt-2 ">Shop Name</h3>
                  </div>
                  <div className="col-6">
                    <h3 className="float-right  mt-2">
                      {CONFIG.DATA.RSA_CLIENT_APP_NAME}
                    </h3>
                  </div>
                </div>

                {is_payments ? (
                  <div className="row">
                    <div className="col-12">
                      <h5 className="bold-title mt-2">
                        Order Summary [{cartlist.length}]
                      </h5>
                      <button
                        onClick={() => {
                          setis_payments(!is_payments);
                        }}
                        className="btn btn-info w-50 mt-3 mb-3"
                      >
                        Back to Shop
                      </button>
                    </div>
                    <div className="col-12">
                      <div className="box_wrap">
                        <div>
                          <div className="">
                            {cartlist.length ? (
                              <div>
                                <div className="row">
                                  <div className="col-12">
                                    <hr />
                                    <h3>Pay Now</h3>
                                  </div>
                                  <div className="col-12">
                                    <div className="mt-5">
                                      <ul className="list-group ">
                                        <li
                                          onClick={() => {
                                            dumypaymet("Paypal");
                                          }}
                                          className="list-group-item borderless"
                                        >
                                          <i className=" fa fa-4x fa-cc-paypal"></i>
                                        </li>
                                        <li
                                          onClick={() => {
                                            dumypaymet("Visa");
                                          }}
                                          className="list-group-item borderless"
                                        >
                                          <i className=" fa fa-4x fa-cc-visa"></i>
                                        </li>
                                        <li
                                          onClick={() => {
                                            dumypaymet("Mastercard");
                                          }}
                                          className="list-group-item borderless"
                                        >
                                          <i className=" fa fa-4x fa-cc-mastercard"></i>
                                        </li>
                                        <li
                                          onClick={() => {
                                            dumypaymet("discover");
                                          }}
                                          className="list-group-item borderless"
                                        >
                                          <i className=" fa fa-4x fa-cc-discover"></i>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ) : (
                              <div className="justify-content-center w-100">
                                <h2>Empty Cart</h2>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-12">
                      <table className="font-20 border">
                        <tbody>
                          <tr>
                            <td className="text-left">Sub Total</td>
                            <td className="text-right">
                              {" "}
                              ${carttotal.sub_total.toFixed(2)}
                            </td>
                          </tr>
                          <tr>
                            <td className="text-left">Tax</td>
                            <td className="text-right">
                              {" "}
                              ${carttotal.tax.toFixed(2)}
                            </td>
                          </tr>
                          <tr>
                            <td className="text-left hightlighted">
                              Net Payable
                            </td>
                            <td className="text-right">
                              <b>
                                {" "}
                                $
                                {(carttotal.sub_total + carttotal.tax).toFixed(
                                  2
                                )}
                              </b>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                ) : (
                  <div className="row">
                    <div className="col-12">
                      <div className="box_wrap">
                        <div>
                          <div className="short-detail">
                            <table className="cart-summary item-yk table">
                              <thead>
                                <tr>
                                  <td>#</td>
                                  <td>QTY</td>
                                  <td>Amount</td>
                                  <td>...</td>
                                </tr>
                              </thead>
                              <tbody>
                                {cartlist.length ? (
                                  cartlist.map((item, key) => {
                                    return (
                                      <tr
                                        key={key}
                                        className="physical_product_tab-js"
                                      >
                                        <td className="text-center">
                                          <div className="product-img">
                                            <a href="#">
                                              <img
                                                src={item.ImagePath}
                                                alt="DCC Cashews"
                                                title="DCC Cashews"
                                              />
                                            </a>
                                          </div>
                                        </td>
                                        <td className="text-left">
                                          <div className="item-yk-head">
                                            <div className="item-yk-head-title">
                                              <a href="#">{item.ProductName}</a>
                                            </div>
                                            <div className="item-yk-head-specification cart_Quantity">
                                              <form>
                                                <div
                                                  className="value-button"
                                                  id="decrease"
                                                  onClick={() =>
                                                    managequantity(key, -1)
                                                  }
                                                >
                                                  -
                                                </div>
                                                <input
                                                  type="number"
                                                  id="number"
                                                  readOnly
                                                  value={item.quantity}
                                                />
                                                <div
                                                  className="value-button"
                                                  id="increase"
                                                  onClick={() =>
                                                    managequantity(key, 1)
                                                  }
                                                >
                                                  +
                                                </div>
                                              </form>
                                            </div>
                                          </div>
                                        </td>
                                        <td>
                                          <div className="product_price">
                                            <span>Amount:</span>
                                            <span className="item__price">
                                              {" "}
                                              $
                                              {(
                                                item.Amount * item.quantity
                                              ).toFixed(2)}{" "}
                                            </span>
                                          </div>
                                          {item.note ? (
                                            <OverlayTrigger
                                              overlay={
                                                <Tooltip id="tooltip-disabled">
                                                  <p>{item.note}</p>
                                                </Tooltip>
                                              }
                                            >
                                              <span className="d-inline-block">
                                                <Button
                                                  disabled
                                                  variant="secondary"
                                                  size="sm"
                                                  style={{
                                                    pointerEvents: "none",
                                                  }}
                                                >
                                                  <i className="fa fa-sticky-note-o text-"></i>
                                                </Button>
                                              </span>
                                            </OverlayTrigger>
                                          ) : (
                                            ""
                                          )}
                                        </td>
                                        <td className="text-right">
                                          <button
                                            onClick={() => {
                                              if (
                                                window.confirm(
                                                  "Are you shour to remove item from cart?"
                                                )
                                              )
                                                removeFromCart(key);
                                            }}
                                            className="btn btn-sm btn-secondary"
                                          >
                                            <i className="fa fa-trash"></i>
                                          </button>
                                        </td>
                                      </tr>
                                    );
                                  })
                                ) : (
                                  <tr>
                                    <td colSpan="4">
                                      <h2>Empty Cart</h2>
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                          <div className="cartdetail__footer font-20 ">
                            <table>
                              <tbody>
                                <tr>
                                  <td className="text-left">Sub Total</td>
                                  <td className="text-right ">
                                    {" "}
                                    ${carttotal.sub_total.toFixed(2)}
                                  </td>
                                </tr>
                                <tr>
                                  <td className="text-left">Tax</td>
                                  <td className="text-right">
                                    {" "}
                                    ${carttotal.tax.toFixed(2)}
                                  </td>
                                </tr>
                                <tr>
                                  <td className="text-left hightlighted">
                                    Net Payable
                                  </td>
                                  <td className="text-right">
                                    <b>
                                      {" "}
                                      $
                                      {(
                                        carttotal.sub_total + carttotal.tax
                                      ).toFixed(2)}
                                    </b>
                                  </td>
                                </tr>
                                <tr>
                                  <td className="text-left">
                                    <button
                                      href="#"
                                      className="btn btn-primary ripplelink"
                                      onClick={() => setiscoupan(!iscoupan)}
                                    >
                                      I Have A Coupon{" "}
                                    </button>
                                  </td>
                                  <td className="text-right">
                                    <button
                                      className="btn btn-secondary ripplelink"
                                      onClick={() => {
                                        setis_payments(!is_payments);
                                      }}
                                    >
                                      Proceed To Pay
                                    </button>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function Storetiming() {
  const StoreTime = ls.get("StoreTime");
  const [StoreTimeList, setStoretimelist] = useState([
    { time: "10:00 am to 11am" },
    { time: "12:00 am to 1:00 pm" },
    { time: "03:00 pm to 05:00 pm" },
  ]);
  const [MyPickupTime, setMyPickupTime] = useState(StoreTime || "");
  const [model, setModels] = useState(false);

  function settime(time) {
    setMyPickupTime(time);
    setModels(false);
    toast.warn("Store pickup time is changed.", {
      autoClose: 2000,
      position: "top-center",
    });
  }

  useEffect(() => {
    ls.set("StoreTime", MyPickupTime);
  }, [MyPickupTime]);

  return (
    <React.Fragment>
      <div
        style={{
          border: "1px solid gray",
          padding: "4px",
          marginTop: "10px",
          textAlign: "left",
        }}
      >
        You select pick up time{" "}
        <b style={{ color: "red" }}>
          {MyPickupTime || "selct one Pickup Time"}
        </b>
        <Link
          to="#"
          className="text-primary"
          style={{ display: "block" }}
          onClick={() => {
            setModels(true);
          }}
        >
          Change Store Pickup Time
        </Link>
      </div>

      <Modal
        show={model}
        size="sm"
        dialogClassName="modal-50w"
        onHide={() => {
          setModels(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Pickup Availability</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className=" col-12">
              <ul className="list-group list-group-flush">
                {StoreTimeList.map((list, key) => {
                  return (
                    <li
                      key={key}
                      className="list-group-item"
                      onClick={() => {
                        settime(list.time);
                      }}
                    >
                      {list.time}
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
}

export default Shop;
